import { render } from "./TableWithOuterFilter.vue?vue&type=template&id=0b2253df&scoped=true&ts=true"
import script from "./TableWithOuterFilter.vue?vue&type=script&lang=ts"
export * from "./TableWithOuterFilter.vue?vue&type=script&lang=ts"

import "./TableWithOuterFilter.vue?vue&type=style&index=0&id=0b2253df&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2253df"]])

export default __exports__